/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  RxntTokenResponseDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    RxntTokenResponseDtoFromJSON,
    RxntTokenResponseDtoToJSON,
} from '../models/index';

/**
 * 
 */
export class ProviderApi extends runtime.BaseAPI {

    /**
     * Retrieves RXNT access token for the currently authenticated provider by exchanging their RXNT credentials. The token can be used by the frontend to make direct calls to RXNT EHR API. Providers can only access their own RXNT credentials.
     * Get RXNT access token for authenticated provider
     */
    async getRxntCredentialsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RxntTokenResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/rxnt-credentials`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RxntTokenResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves RXNT access token for the currently authenticated provider by exchanging their RXNT credentials. The token can be used by the frontend to make direct calls to RXNT EHR API. Providers can only access their own RXNT credentials.
     * Get RXNT access token for authenticated provider
     */
    async getRxntCredentials(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RxntTokenResponseDto> {
        const response = await this.getRxntCredentialsRaw(initOverrides);
        return await response.value();
    }

}
